module.exports = __webpack_public_path__ + "media/Video 15b.5e7ef9f8.mp4";